import { useState, useEffect } from 'react';
import { ModalCategories } from 'components/Modal/ModalTransaction/Category/ModalCategory';
import {
  CategoryBtn,
  CategoryContainer,
  CategoryText,
  Text,
  SelectedCategoryBtn,
} from 'components/Modal/ModalTransaction/ModalTransaction.styled';
import { useTranslation } from 'react-i18next';
import {
  BadgePercent,
  Bitcoin,
  Bus,
  Car,
  CircleHelp,
  Dumbbell,
  Gamepad2,
  Gift,
  GraduationCap,
  HandCoins,
  HeartHandshake,
  Home,
  Landmark,
  PawPrint,
  Pill,
  Plane,
  Plus,
  Receipt,
  Shirt,
  ShoppingBasket,
  Sparkles,
  ToyBrick,
  Truck,
  UtensilsCrossed,
  Wifi,
} from 'lucide-react';

const categoryIconMap = {
  'icon-education': GraduationCap,
  'icon-entertainment': Gamepad2,
  'icon-fashion': Shirt,
  'icon-gifts': Gift,
  'icon-groceries': ShoppingBasket,
  'icon-household': Home,
  'icon-Interest': BadgePercent,
  'icon-internet': Wifi,
  'icon-paydayLoans': HandCoins,
  'icon-medical': Pill,
  'icon-pets': PawPrint,
  'icon-rent': Landmark,
  'icon-restaurants': UtensilsCrossed,
  'icon-salary': Landmark,
  'icon-self': Sparkles,
  'icon-shipping': Truck,
  'icon-sport': Dumbbell,
  'icon-toys': ToyBrick,
  'icon-transport': Bus,
  'icon-trips': Plane,
  'icon-utilities': Receipt,
  'icon-charity': HeartHandshake,
  'icon-Car-service': Car,
  'icon-bitcoin': Bitcoin,
  'icon-noCategory': CircleHelp,
};

export const Category = ({
  icon,
  setIcon,
  setSelectedCategory,
  selectedCategory,
  transactionToEdit,
}) => {
  const { t } = useTranslation();
  const category = t('category', { returnObjects: true });
  const categoryList = Object.values(category);
  const [categories, setCategories] = useState(categoryList.slice(0, 3));
  const [categoriesMore, setCategoriesMore] = useState(categoryList);
  const [modalOpen, setModalOpen] = useState(false);
  const [narrowCategoryBar, setNarrowCategoryBar] = useState(
    typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 560px)').matches
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 560px)');
    const sync = () => setNarrowCategoryBar(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      const updatedCategories = [...categoriesMore];
      const clickedCategoryIndex = updatedCategories.findIndex(
        category => category.id === icon
      );
      if (clickedCategoryIndex !== -1) {
        const clickedCategory = updatedCategories.splice(
          clickedCategoryIndex,
          1
        )[0];

        updatedCategories.unshift(clickedCategory);
      }
      setCategories(updatedCategories.slice(0, 3));
    }
  }, [categoriesMore, icon, selectedCategory]);

  const toggleModal = () => {
    setModalOpen(prevState => !prevState);
  };

  const handleCategoryClick = (id, categoryName) => {
    const updatedCategories = [...categoriesMore];
    const clickedCategoryIndex = updatedCategories.findIndex(
      category => category.id === id
    );
    if (clickedCategoryIndex !== -1) {
      const clickedCategory = updatedCategories.splice(
        clickedCategoryIndex,
        1
      )[0];

      updatedCategories.unshift(clickedCategory);
    }
    setCategories(updatedCategories.slice(0, 3));
    setIcon(id);
    setSelectedCategory(id);
  };

  return (
    <CategoryContainer
      style={{ paddingLeft: '4px', paddingRight: '4px', marginBottom: '12px' }}
    >
      {categories.slice(0, 3).map(({ id, categoryName }) => (
        <li key={id}>
          {(() => {
            const Icon = categoryIconMap[id] || CircleHelp;
            return selectedCategory === id ? (
              <SelectedCategoryBtn
                type="button"
                onClick={() => handleCategoryClick(id, categoryName)}
              >
                <Icon
                  size={20}
                  color="#FF7601"
                  stroke="#FF7601"
                  strokeWidth={2.25}
                  style={{
                    display: 'block',
                    margin: 0,
                  }}
                />
                <CategoryText
                  text={categoryName}
                  length={narrowCategoryBar ? 32 : 9}
                />
              </SelectedCategoryBtn>
            ) : (
              <CategoryBtn
                type="button"
                onClick={() => handleCategoryClick(id, categoryName)}
              >
                <Icon
                  size={20}
                  color="#FF7601"
                  stroke="#FF7601"
                  strokeWidth={2.25}
                  style={{
                    display: 'block',
                    margin: 0,
                  }}
                />
                <CategoryText
                  text={categoryName}
                  length={narrowCategoryBar ? 32 : 9}
                />
              </CategoryBtn>
            );
          })()}
        </li>
      ))}
      <li>
        <CategoryBtn type="button" onClick={toggleModal}>
          <Plus size={24} color="#FF7601" style={{ margin: 0 }} />
          <Text>{t('madalGeneral.more')}</Text>
        </CategoryBtn>
      </li>
      {modalOpen && (
        <ModalCategories
          categoriesMore={categoriesMore}
          setCategoriesMore={setCategoriesMore}
          setIcon={setIcon}
          onClose={toggleModal}
          setCategories={setCategories}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          transactionToEdit={transactionToEdit}
        />
      )}
    </CategoryContainer>
  );
};
